export const oAuthRecoverStyles = (theme) => ({
  button: {
    color: theme.palette.grey[50],
    marginTop: theme.spacing(1),
    textAlign: theme.wrappers.alignCenter,
    width: theme.wrappers.fullWidth,
  },
});
